import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify' // Vuetify eklentisi
import { loadFonts } from './plugins/webfontloader' // Vuetify fontları için

loadFonts() // Fontları yükle

createApp(App)
  .use(router) // Vue Router'ı kullan
  .use(store)  // Vuex Store'u kullan
  .use(vuetify) // Vuetify'ı kullan
  .mount('#app') // Uygulamayı HTML'e bağla